// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38eoD","field":"styles_field__30_5D","fieldCol":"styles_fieldCol__3f6UH","diffCol":"styles_diffCol__3EX60","diff":"styles_diff__1XiDs"};